/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { AllasStandalonePaymentCompletedDialog as ResolvedStandalonePaymentCompletedDialog } from 'sites/allas/components/standalone/PaymentCompletedDialog';

export const PaymentCompletedDialog: typeof ResolvedStandalonePaymentCompletedDialog = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandalonePaymentCompletedDialog {...props} />
    );
});

export type PaymentCompletedDialogProps = PropsFromComponent<typeof PaymentCompletedDialog>;

/** @deprecated Use slot architecture instead */
export const PaymentCompletedDialogWith = (extras: DynamicStandaloneExtras): typeof PaymentCompletedDialog => {
    return function PaymentCompletedDialog(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'PaymentCompletedDialog');
        return <ResolvedStandalonePaymentCompletedDialog {...mergeProps({ options: { theme } }, props)} />;
    }
}